export const isFieldConfigurationConflict = (definition) => {
  return Boolean(definition && definition.ConfigurationConflict);
};

export const isSettingsChangeBlocked = (definitions, changes) => {
  const conflicts = new Set(Object.values(definitions || {}).filter(isFieldConfigurationConflict).map((row) => row.Name));
  return Object.keys(changes || {}).some((name) => conflicts.has(name));
};

export const getConflictedFieldForChanges = (definitions, changes) => {
  return Object.values(definitions || {}).find((definition) => {
    return isFieldConfigurationConflict(definition) && Object.prototype.hasOwnProperty.call(changes || {}, definition.Name);
  });
};

export const fieldSettingsErrorMessage = (result, { field, departmentId } = {}) => {
  if (result && result.code === 'FIELD_CONFIGURATION_CONFLICT') {
    const fieldName = field && field.Name;
    const fieldLabel = (field && field.Alias) || fieldName;
    if (fieldName && departmentId !== undefined && departmentId !== null) {
      return `The ${fieldLabel} field has conflicting definitions in department ${departmentId}. It is unavailable until support repairs the duplicate definitions. Contact support with department ID ${departmentId} and field name ${fieldName}.`;
    }
    return 'This field has conflicting definitions. It is unavailable until support repairs the duplicate definitions.';
  }
  return 'Field settings could not be saved. Refresh Manage Fields before retrying.';
};
